import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import Sandbox from './sandbox';
// import { getNSGlobalSettingsPageInfo } from '../../../redux/actions/settings';
import {
  getAMLSCommonSandboxUI,
  resetAMLSCommonSandboxUIResults
} from '../../redux/actions/common';

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    searchResults: state.amlsCommon.sandboxResult,
    isAppLoading: state.app.isFetching
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path) => push(path),
        getAMLSCommonSandboxUI,
        resetAMLSCommonSandboxUIResults
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Sandbox);
